<template>
  <v-card class="mx-auto" flat>
    <v-card-text>
      <v-container>
        <v-stepper v-model="step" class="elevation-0">
          <v-stepper-header class="elevation-0" style="border: 1px solid rgba(0, 0, 0, 0.12); padding: 0 15%">
            <v-stepper-step :color="step > 1 ? 'success' : 'primary'" :complete="step > 1" step="1">
              Data Peserta
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="2"> Konfirmasi Data </v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1" style="padding: 0">
              <v-card flat>
                <v-card-text class="pa-0 pt-7">
                  <div class="my-5">
                    <div class="text-h6 black--text my-4">Data Peserta</div>
                    <v-row v-if="!isEdit">
                      <v-col cols="12" lg="6" md="6">
                        <validation-provider name="nik" rules="required" v-slot="{ errors }">
                          <div class="label--text">NIK <span class="red--text">*</span></div>
                          <v-text-field
                            v-model="form.nik"
                            placeholder="Cari NIK"
                            :error-messages="errors"
                            dense
                            outlined
                            single-line
                            v-mask="'################'"
                            counter="16"
                            required
                          ></v-text-field>
                        </validation-provider>
                      </v-col>
                      <v-col cols="12" lg="6" md="6">
                        <div class="mt-6">
                          <v-btn class="orange white--text" :disabled="!form.nik" @click="onSearchNik">
                            <v-icon left>mdi-magnify</v-icon> Cari Data
                          </v-btn>
                        </div>
                      </v-col>
                      <v-col v-if="infoNik" cols="12" md="12" sm="12">
                        <v-alert type="info" text>
                          {{ infoNik }}
                        </v-alert>
                      </v-col>
                    </v-row>
                    <base-form-generator :schema="schema.umum" v-model="form" />
                  </div>
                  <div class="my-3">
                    <div class="text-h6 black--text my-4">Data Unit Kerja</div>
                    <v-row>
                      <v-col cols="12" lg="6">
                        <validation-provider name="NPSN" rules="required" v-slot="{ errors }">
                          <div class="label--text">NPSN <span class="red--text">*</span></div>
                          <v-text-field
                            v-model="form.unit_npsn"
                            placeholder="Tuliskan NPSN"
                            :disabled="$isObject(sekolah)"
                            :error-messages="errors"
                            dense
                            outlined
                            single-line
                            required
                          ></v-text-field>
                        </validation-provider>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <div class="mt-6" v-if="!$isObject(sekolah)">
                          <v-btn :disabled="!form.unit_npsn" class="orange white--text" @click="onSearchSekolah">
                            <v-icon left>mdi-magnify</v-icon> Cari Data
                          </v-btn>
                        </div>
                        <div class="mt-6" v-else>
                          <v-btn class="red white--text" @click="onRemoveSekolah">
                            <v-icon left>mdi-close</v-icon> Ganti Sekolah
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>
                    <base-form-generator v-if="$isObject(sekolah)" :schema="schema.unitkerja" v-model="form" />
                  </div>
                  <div class="my-3">
                    <div class="text-h6 black--text my-4">Data Diklat</div>
                    <base-form-generator :schema="schema.diklat" v-model="form" />
                  </div>
                  <div class="my-3">
                    <div class="text-h6 black--text my-4">Data Unggahan</div>
                    <v-row>
                      <v-col cols="12" md="6" sm="12">
                        <span :class="[`px-0 body-2 label--text`]" style="height: 24px">
                          Unggah Sertifikat/Ijazah <span class="red--text">*</span>
                          <v-icon small right color="orange" @click="panduan = true" style="cursor: pointer">
                            mdi-information
                          </v-icon>
                        </span>
                        <template v-if="files && files.sertifikat">
                          <div class="mt-2">
                            <v-btn color="secondary" depressed small @click="onView('sertifikat')">
                              <v-icon left>mdi-eye</v-icon> Preview
                            </v-btn>
                            <v-btn class="mx-2" color="primary" depressed small @click="onDelete('sertifikat')">
                              <v-icon left>mdi-pencil</v-icon> Ubah Berkas
                            </v-btn>
                          </div>
                        </template>
                        <template v-else>
                          <validation-provider name="Sertifikat Diklat" rules="required" v-slot="{ errors }">
                            <v-file-input
                              v-model="form.file_sertifikat"
                              :error-messages="errors"
                              label="Pindaian Berkas Sertifikat (20 KB - 1,5 MB)"
                              append-icon="mdi-paperclip"
                              prepend-icon=""
                              accept="image/*,.pdf"
                              hint=""
                              :rules="[
                                (value) =>
                                  (value && value.size < roundDecimal(1500 * 1000)) ||
                                  'Berkas yang Anda upload melebihi kapasitas maksimum!',
                              ]"
                              persistent-hint
                              show-size
                              outlined
                              dense
                              single-line
                              @change="checkFile"
                            ></v-file-input>
                          </validation-provider>
                        </template>
                      </v-col>
                      <v-col cols="12" md="6" sm="12">
                        <span :class="[`px-0 body-2 label--text`]" style="height: 24px">
                          Unggah Scan KTP
                          <v-icon v-if="false" small right color="orange">mdi-information</v-icon>
                        </span>
                        <template v-if="files && files.ktp">
                          <div class="mt-2">
                            <v-btn color="secondary" depressed small @click="onView('ktp')">
                              <v-icon left>mdi-eye</v-icon> Preview
                            </v-btn>
                            <v-btn class="mx-2" color="primary" depressed small @click="onDelete('ktp')">
                              <v-icon left>mdi-pencil</v-icon> Ubah Berkas
                            </v-btn>
                          </div>
                        </template>
                        <template v-else>
                          <v-file-input
                            v-model="form.file_ktp"
                            label="File scan KTP (20 KB - 1,5 MB)"
                            append-icon="mdi-paperclip"
                            prepend-icon=""
                            accept="image/*,.pdf"
                            hint=""
                            :rules="[
                              (value) =>
                                (value && value.size < roundDecimal(1500 * 1000)) ||
                                'Berkas yang Anda upload melebihi kapasitas maksimum!',
                            ]"
                            persistent-hint
                            show-size
                            outlined
                            dense
                            single-line
                          ></v-file-input>
                        </template>
                      </v-col>
                      <v-col cols="12" md="6" sm="12">
                        <span :class="[`px-0 body-2 label--text`]" style="height: 24px">
                          Unggah Surat Keterangan Mengajar <span class="red--text">*</span>
                        </span>
                        <template v-if="files && files.sk_instansi">
                          <div class="mt-2">
                            <v-btn color="secondary" depressed small @click="onView('sk_instansi')">
                              <v-icon left>mdi-eye</v-icon> Preview
                            </v-btn>
                            <v-btn class="mx-2" color="primary" depressed small @click="onDelete('sk_instansi')">
                              <v-icon left>mdi-pencil</v-icon> Ubah Berkas
                            </v-btn>
                          </div>
                        </template>
                        <template v-else>
                          <validation-provider name="Surat Keterangan Mengajar" rules="required" v-slot="{ errors }">
                            <v-file-input
                              v-model="form.file_sk_instansi"
                              :error-messages="errors"
                              label="File jpg.png.pdf (20 KB - 1,5 MB)"
                              append-icon="mdi-paperclip"
                              prepend-icon=""
                              accept="image/*,.pdf"
                              hint=""
                              :rules="[
                                (value) =>
                                  (value && value.size < roundDecimal(1500 * 1000)) ||
                                  'Berkas yang Anda upload melebihi kapasitas maksimum!',
                              ]"
                              persistent-hint
                              show-size
                              outlined
                              dense
                              single-line
                            ></v-file-input>
                          </validation-provider>
                        </template>
                      </v-col>
                    </v-row>
                  </div>
                  <v-divider class="my-2" />
                </v-card-text>
                <v-card-actions class="pa-0">
                  <span class="grey--text font-italic">Form dengan tanda (*) wajib di isi</span>
                  <v-spacer></v-spacer>
                  <v-btn v-if="step !== 1" class="text-md-right" right text> Kembali </v-btn>
                  <v-btn class="text-md-right" right color="primary" @click="onValidate(true)"> Selanjutnya </v-btn>
                </v-card-actions>
              </v-card>
            </v-stepper-content>
            <v-stepper-content step="2" style="padding: 0">
              <v-card flat>
                <v-card-text class="pa-0 pt-7">
                  <h2 class="secondary--text">Konfirmasi {{ isEdit ? 'Ubah' : 'Tambah' }} Peserta</h2>
                  <v-row class="my-2">
                    <v-col cols="12" md="2" sm="12">
                      <v-avatar color="primary" size="100">
                        <v-icon dark size="80">mdi-account-circle</v-icon>
                      </v-avatar>
                    </v-col>
                    <v-col cols="12" md="10" sm="12" class="px-0">
                      <base-list-info class="px-0" tipe="row" :info="info"></base-list-info>
                      <div>
                        <span class="caption">File Sertifikat : </span>
                        <v-btn class="mx-2" color="blue" outlined small depressed @click="onView('sertifikat')">
                          Lihat Sertifikat
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions class="pa-0">
                  <v-spacer></v-spacer>
                  <v-btn
                    right
                    text
                    @click="
                      () => {
                        step--;
                        $emit('onStep');
                      }
                    "
                  >
                    Sebelumnya
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-container>
    </v-card-text>
    <v-dialog v-model="panduan" max-width="800" :scrollable="false" @keydown.esc="panduan = false">
      <v-card>
        <v-toolbar flat>
          <v-toolbar-title>Unggah Sertifikat / Ijazah Terakhir</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="panduan = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text class="black--text">
          <v-row class="pa-2">
            <v-col cols="12" md="3" sm="12">
              <v-img
                class="ma-5"
                src="https://cdn.siap.id/s3/simpkb/asset%20img/ayo%20guru%20belajar%20&%20berbagi/GTK-PAUD/icon_keterangan_certification.png"
              >
              </v-img>
            </v-col>
            <v-col cols="12" md="9" sm="12">
              <div class="body-1 font-weight-medium mt-2">Ketentuan Unggah Sertifikat</div>
              <table>
                <tr>
                  <td><v-icon left color="success">mdi-check-circle</v-icon></td>
                  <td
                    >Peserta yang mau mengikuti
                    <b>Diklat Dasar harus mengunggah Ijazah Terakhir (mininmal SMA sederajat)</b></td
                  >
                </tr>
                <tr>
                  <td><v-icon left color="success">mdi-check-circle</v-icon></td>
                  <td>Peserta yang mau mengikuti <b>Diklat Lanjut harus mengunggah sertifikat Diklat Dasar</b></td>
                </tr>
                <tr>
                  <td><v-icon left color="success">mdi-check-circle</v-icon></td>
                  <td>Peserta yang mau mengikuti <b>Diklat Mahir harus mengunggah sertifikat Diklat Lanjut</b></td>
                </tr>
              </table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import BaseFormGenerator from '@components/base/BaseFormGenerator';
import BaseListInfo from '@components/base/BaseListInfo';
import { ValidationProvider } from 'vee-validate';
import { roundDecimal } from '@utils/format';
import { mapActions } from 'vuex';

export default {
  props: {
    masters: {
      type: Object,
      default: () => {},
    },
    initValue: {
      type: Object,
      default: () => null,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  components: { BaseFormGenerator, BaseListInfo, ValidationProvider },
  data() {
    return {
      step: null,
      form: {},
      files: {},
      sekolah: {},
      url_file: null,
      panduan: false,
      masterUnit: {},
      infoNik: '',
    };
  },
  computed: {
    configs() {
      const M_PROPINSI = this.masters.m_propinsi || {};
      const M_KOTA = this.masters.m_kota || {};
      const M_KECAMATAN = this.masters.m_kecamatan || {};
      const M_KELURAHAN = this.masters.m_kelurahan || {};
      const config = {
        selector: ['k_propinsi', 'k_kota', 'k_kecamatan', 'k_kelurahan'],
        required: ['k_propinsi', 'k_kota', false, 'k_kelurahan'],
        label: ['Provinsi', 'Kota/Kabupaten', 'Kecamatan', 'Kelurahan'],
        options: [M_PROPINSI, M_KOTA, M_KECAMATAN, M_KELURAHAN],
        grid: [{ cols: 6 }, { cols: 6 }, { cols: 6 }],
        useSchema: true,
      };
      return {
        peserta: Object.assign({}, config),
        // unitkerja: Object.assign({}, config, {
        //   selector: ['unit_k_propinsi', 'unit_k_kota'],
        //   required: ['unit_k_propinsi', 'unit_k_kota'],
        //   label: ['Provinsi', 'Kota/Kabupaten'],
        // }),
      };
    },

    info() {
      return [
        [
          {
            key: 'nama',
            label: 'Nama',
            value: this.$getDeepObj(this.form, 'nama') || '-',
          },
          {
            key: 'email',
            label: 'Alamat Email',
            value: this.$getDeepObj(this.form, 'email') || '-',
          },
        ],
        [
          {
            key: 'nik',
            label: 'NIK',
            value: this.$getDeepObj(this.form, 'nik') || '-',
          },
          {
            key: 'no_hp',
            label: 'Nomor Telepon',
            value: this.$getDeepObj(this.form, 'no_hp') || '-',
          },
        ],
        [
          {
            key: 'lahir',
            label: 'Tempat, Tanggal Lahir',
            value: this.$getDeepObj(this.form, 'tmp_lahir') || '-',
          },
          {
            key: 'kelamin',
            label: 'Jenis Kelamin',
            value:
              this.$getDeepObj(this.form, 'kelamin') === 'L'
                ? 'Laki - laki'
                : this.$getDeepObj(this.form, 'kelamin') === 'P'
                ? 'Perempuan'
                : '',
          },
        ],
        [
          {
            key: 'tgl_lahir',
            label: 'Tanggal Lahir',
            value: this.$localDate(this.$getDeepObj(this.form, 'tgl_lahir') || '-'),
          },
          {
            key: 'unit_kerja',
            label: 'Unit Kerja',
            value: [
              this.$getDeepObj(this.sekolah, 'nama') || '-',
              this.$getDeepObj(this.sekolah, `m_kota.keterangan`) || '-',
              this.$getDeepObj(this.sekolah, `m_propinsi.keterangan`) || '-',
            ].join(', '),
          },
        ],
        [
          {
            key: 'alamat',
            label: 'Alamat',
            value: [
              this.$getDeepObj(this.form, 'alamat') || '-',
              this.$getDeepObj(this.masters, `m_propinsi.${Number(this.form.k_propinsi)}`) || '-',
              this.$getDeepObj(this.masters, `m_kota.${Number(this.form.k_kota)}`) || '-',
            ].join(',<br/>'),
          },
          {
            key: 'npsn',
            label: 'Unit Kerja NPSN',
            value: this.$getDeepObj(this.sekolah, 'npsn') || '-',
          },
        ],
        [
          {
            key: 'kualifikasi_paud',
            label: 'Pendidikan',
            value: this.form['k_kualifikasi_paud']
              ? this.masters['m_kualifikasi_paud'][Number(this.form['k_kualifikasi_paud'])]
              : '',
          },
          {
            key: 'guru_paud',
            label: 'Jenis Guru',
            value: this.form['k_guru_paud'] ? this.masters['m_guru_paud'][Number(this.form['k_guru_paud'])] : '',
          },
        ],
        [
          {
            key: 'jenjang_diklat',
            label: 'Jenis Diklat',
            value: [
              this.form['k_diklat_paud'] ? this.masters['m_diklat_paud'][Number(this.form['k_diklat_paud'])] : '',
              this.form['k_jenjang_diklat_paud']
                ? this.masters['m_jenjang_diklat_paud'][Number(this.form['k_jenjang_diklat_paud'])]
                : '',
            ].join('<br/>'),
          },
        ],
      ];
    },

    schema() {
      return {
        umum: [
          {
            type: 'VTextField',
            name: 'nama',
            label: 'Nama Lengkap',
            dense: true,
            hint: 'wajib diisi',
            required: true,
            hideDetails: false,
            outlined: true,
            singleLine: true,
            grid: { cols: 12, md: this.isEdit ? 6 : 12 },
            labelColor: 'secondary',
            counter: 100,
          },
          ...(this.isEdit
            ? [
                {
                  type: 'VTextField',
                  name: 'nik',
                  label: 'NIK',
                  hint: 'wajib diisi',
                  hideDetails: false,
                  outlined: true,
                  dense: true,
                  singleLine: true,
                  required: true,
                  mask: '################',
                  counter: 16,
                  grid: { cols: 12, md: 6 },
                  labelColor: 'secondary',
                },
              ]
            : []),
          {
            type: 'VTextField',
            name: 'tmp_lahir',
            label: 'Tempat Lahir',
            hint: 'wajib diisi',
            required: true,
            hideDetails: false,
            outlined: true,
            dense: true,
            singleLine: true,
            grid: { cols: 12, md: 3 },
            labelColor: 'secondary',
          },
          {
            type: 'VDatePicker',
            name: 'tgl_lahir',
            label: 'Tanggal Lahir',
            hint: 'wajib diisi',
            required: true,
            hideDetails: false,
            outlined: true,
            dense: true,
            singleLine: true,
            grid: { cols: 12, md: 3 },
            labelColor: 'secondary',
          },
          {
            type: 'VRadio',
            name: 'kelamin',
            label: 'Jenis Kelamin',
            hint: 'wajib diisi',
            items: [
              { value: 'L', text: 'Laki-Laki' },
              { value: 'P', text: 'Perempuan' },
            ],
            required: true,
            hideDetails: false,
            outlined: true,
            dense: true,
            row: true,
            singleLine: false,
            grid: { cols: 12, md: 6 },
            labelColor: 'secondary',
          },
          {
            type: 'VTextField',
            name: 'email',
            label: `Alamat Email`,
            labelColor: 'secondary',
            hideDetails: false,
            placeholder: 'Alamat Email',
            hint: 'wajib diisi',
            grid: { cols: 12, md: 6 },
            outlined: true,
            required: true,
            dense: true,
            disabled: false,
            singleLine: true,
          },
          {
            type: 'VTextField',
            name: `no_hp`,
            label: `Nomor HP/WA`,
            labelColor: 'secondary',
            hideDetails: false,
            placeholder: 'Nomor Handphone',
            hint: '',
            grid: { cols: 12, md: 6 },
            required: false,
            dense: true,
            outlined: true,
            singleLine: true,
            mask: '##############',
            counter: 14,
          },
          {
            type: 'VTextarea',
            name: 'alamat',
            label: 'Alamat Sesuai KTP',
            hint: 'wajib diisi',
            grid: { cols: 12 },
            required: true,
            outlined: true,
            dense: true,
            singleLine: true,
            labelColor: 'secondary',
          },
          {
            type: 'cascade',
            configs: this.configs.peserta,
            grid: { cols: 12 },
            labelColor: 'secondary',
          },
          {
            type: 'VSelect',
            name: 'k_kualifikasi_paud',
            label: 'Pendidikan',
            hint: 'wajib diisi',
            items: this.mKualifikasi,
            value: 'value',
            text: 'text',
            required: true,
            hideDetails: false,
            outlined: true,
            dense: true,
            singleLine: true,
            grid: { cols: 12, md: 6 },
            labelColor: 'secondary',
          },
          {
            type: 'VSelect',
            name: 'k_guru_paud',
            label: 'Jenis Guru',
            hint: 'wajib diisi',
            items: this.$mapForMaster(this.masters.m_guru_paud),
            value: 'value',
            text: 'text',
            required: true,
            hideDetails: false,
            outlined: true,
            dense: true,
            singleLine: true,
            grid: { cols: 12, md: 6 },
            labelColor: 'secondary',
          },
        ],
        unitkerja: [
          {
            type: 'TextView',
            name: 'unit_kerja',
            label: 'Unit Kerja',
            value: this.$getDeepObj(this.sekolah, 'nama') || '-',
            grid: { cols: 12 },
          },
          {
            type: 'TextView',
            name: 'unit_kerja_propinsi',
            label: 'Provinsi',
            value: this.$getDeepObj(this.sekolah, 'm_propinsi.keterangan') || '-',
            grid: { cols: 12, md: 6, sm: 6 },
          },
          {
            type: 'TextView',
            name: 'unit_kerja_kota',
            label: 'Kota',
            value: this.$getDeepObj(this.sekolah, 'm_kota.keterangan') || '-',
            grid: { cols: 12, md: 6, sm: 6 },
          },
          {
            type: 'TextView',
            name: 'unit_kerja_kecamatan',
            label: 'Kecamatan',
            value: this.$getDeepObj(this.sekolah, 'm_kecamatan.keterangan') || '-',
            grid: { cols: 12, md: 6, sm: 6 },
          },
          {
            type: 'TextView',
            name: 'unit_kerja_kelurahan',
            label: 'Kelurahan',
            value: this.$getDeepObj(this.sekolah, 'kelurahan') || '-',
            grid: { cols: 12, md: 6, sm: 6 },
          },
        ],
        diklat: [
          {
            type: 'VSelect',
            name: 'k_jenjang_diklat_paud',
            label: 'Jenjang Diklat',
            hint: 'wajib diisi',
            items: this.$mapForMaster(this.masters.m_jenjang_diklat_paud),
            value: 'value',
            text: 'text',
            required: true,
            hideDetails: false,
            outlined: true,
            dense: true,
            singleLine: true,
            grid: { cols: 12, md: 6 },
            labelColor: 'secondary',
          },
          {
            type: 'VSelect',
            name: 'k_diklat_paud',
            label: 'Jenis Diklat',
            hint: 'wajib diisi',
            items: this.$mapForMaster(this.masters.m_diklat_paud),
            value: 'value',
            text: 'text',
            required: true,
            hideDetails: false,
            outlined: true,
            dense: true,
            singleLine: true,
            grid: { cols: 12, md: 6 },
            labelColor: 'secondary',
          },
        ],
        sekolah: [
          {
            type: 'VTextField',
            name: 'npsn',
            label: 'NPSN',
            required: true,
            hideDetails: false,
            outlined: true,
            dense: true,
            singleLine: true,
            grid: { cols: 12, md: 6 },
            labelColor: 'secondary',
          },
        ],
      };
    },

    mKualifikasi() {
      return [
        {
          value: 1,
          text: 'SMA Sederajat',
        },
        {
          value: 5,
          text: 'D1',
        },
        {
          value: 6,
          text: 'D2',
        },
        {
          value: 7,
          text: 'D3',
        },
        {
          value: 8,
          text: 'D4',
        },
        {
          value: 2,
          text: 'S1',
        },
        {
          value: 3,
          text: 'S2',
        },
        {
          value: 4,
          text: 'S3',
        },
      ];
    },
  },
  methods: {
    ...mapActions('peserta', ['fetchKecamatan', 'getInfoSekolah', 'getInfoNik']),

    reset() {
      this.form = {};
      this.files = {};
      this.sekolah = {};
      this.infoNik = '';
      this.url_file = null;
      this.step = 1;
    },

    initForm(value) {
      if (!value) return;
      const formulir = [
        ...(this.schema.umum || []),
        ...(this.schema.diklat || []),
        { name: 'k_propinsi' },
        { name: 'k_kota' },
        { name: 'k_kecamatan' },
        { name: 'k_kelurahan' },
      ];
      for (const item of formulir) {
        if (item.name) {
          this.$set(this.form, item.name, this.$getDeepObj(value, item.name) || '');
        }
      }

      if (value.sekolah_id) {
        this.form.sekolah_id = value.sekolah_id;
        this.form.unit_npsn = this.$getDeepObj(value, 'sekolah.npsn') || this.$getDeepObj(value, 'unit_npsn') || '';
        this.sekolah = this.$getDeepObj(value, 'sekolah') || {};
      }

      const urls = ['sertifikat', 'ktp', 'sk_instansi'];
      urls.forEach((key) => {
        if (value[`${key}_url`]) {
          this.$set(this.files, key, value[`${key}_url`]);
        }
      });
    },

    onValidate() {
      this.$emit('validate', this.sekolah);
    },

    next(status) {
      if (status) this.step = 2;
    },

    resetPilih() {
      this.$emit('reset');
    },

    roundDecimal(value) {
      return roundDecimal(value);
    },

    onDelete(tipe) {
      this.$delete(this.files, tipe);
    },

    onView(tipe) {
      const url = this.$getDeepObj(this, 'url_file') || this.$getDeepObj(this.initValue, `${tipe}_url`);
      window.open(url, '_blank');
    },

    async onSearchSekolah() {
      const { data } = await this.getInfoSekolah({ params: { npsn: this.form.unit_npsn } });
      this.sekolah = data || {};
      this.form.sekolah_id = data.sekolah_id || '';
    },

    async onSearchNik() {
      this.infoNik = '';
      const { data } = await this.getInfoNik({ params: { nik: this.form.nik } });
      if (data && data.length > 0) {
        const schema = [
          ...this.schema.umum,
          { name: 'k_propinsi' },
          { name: 'k_kota' },
          { name: 'k_kecamatan' },
          { name: 'k_kelurahan' },
        ];

        for (const item of schema) {
          if (item.name) {
            this.$set(this.form, item.name, this.$getDeepObj(data[0], item.name) || '');
          }
        }
      } else {
        this.infoNik = 'Data peserta belum pernah ditambahkan, silakan lakukan input data secara manual.';
      }
    },

    onRemoveSekolah() {
      this.sekolah = {};
      delete this.form.sekolah_id;
    },

    checkFile(file) {
      let blob = new Blob([file], { type: `${file.type}` });
      this.url_file = URL.createObjectURL(blob);
    },

    gelurahan(value) {
      if (!value) return;
      this.fetchKecamatan({
        name: ['m_kecamatan'].join(';'),
        filter: {
          0: {
            k_kota: {
              op: '=',
              val: value,
            },
          },
        },
      }).then((resp) => {
        this.$set(this.masterUnit, 'm_kecamatan', (resp && resp.m_kecamatan) || {});
      });
    },

    getKelurahan(value) {
      if (!value) return;
      this.fetchKecamatan({
        name: ['m_kelurahan'].join(';'),
        filter: {
          0: {
            k_kecamatan: {
              op: '=',
              val: value,
            },
          },
        },
      }).then((resp) => {
        this.$set(this.masterUnit, 'm_kelurahan', (resp && resp.m_kelurahan) || {});
      });
    },
  },
  watch: {
    initValue: 'initForm',
    // 'form.unit_k_kota': 'getKecamatan',
    // 'form.unit_k_kecamatan': 'getKelurahan',
  },
};
</script>
